import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
type ModalType = 'privacy' | 'terms' | null;
export function Footer() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  const privacyContent = <div className="space-y-4" data-id="element-32">
      <h2 className="text-2xl font-bold text-[#2C2C2C] mb-4" data-id="element-33">Privacy Policy</h2>

      <section data-id="element-34">
        <h3 className="text-lg font-semibold text-[#2C2C2C] mb-2" data-id="element-35">
          Information We Collect
        </h3>
        <p className="text-[#4A4A4A]" data-id="element-36">
          When you purchase The 7pm Menopause Sleep Reset, we collect your name,
          email address, and payment information necessary to process your order
          and deliver your digital product.
        </p>
      </section>

      <section data-id="element-37">
        <h3 className="text-lg font-semibold text-[#2C2C2C] mb-2" data-id="element-38">
          How We Use Your Information
        </h3>
        <p className="text-[#4A4A4A]" data-id="element-39">We use your information solely to:</p>
        <ul className="list-disc list-inside text-[#4A4A4A] ml-4 mt-2 space-y-1" data-id="element-40">
          <li data-id="element-41">Process and fulfill your order</li>
          <li data-id="element-42">Send you the PDF guide and tracker materials</li>
          <li data-id="element-43">Provide customer support if needed</li>
          <li data-id="element-44">Send occasional product updates (you can opt out anytime)</li>
        </ul>
      </section>

      <section data-id="element-45">
        <h3 className="text-lg font-semibold text-[#2C2C2C] mb-2" data-id="element-46">
          Data Security
        </h3>
        <p className="text-[#4A4A4A]" data-id="element-47">
          We use industry-standard encryption and secure payment processing
          through Stripe. We never store your credit card information on our
          servers.
        </p>
      </section>

      <section data-id="element-48">
        <h3 className="text-lg font-semibold text-[#2C2C2C] mb-2" data-id="element-49">
          Third-Party Services
        </h3>
        <p className="text-[#4A4A4A]" data-id="element-50">
          We use trusted third-party services (Stripe for payments, email
          delivery services) that have their own privacy policies. We do not
          sell or share your personal information with any other parties.
        </p>
      </section>

      <section data-id="element-51">
        <h3 className="text-lg font-semibold text-[#2C2C2C] mb-2" data-id="element-52">
          Your Rights
        </h3>
        <p className="text-[#4A4A4A]" data-id="element-53">
          You have the right to access, correct, or delete your personal
          information at any time. Contact us to exercise these rights.
        </p>
      </section>
    </div>;
  const termsContent = <div className="space-y-4" data-id="element-54">
      <h2 className="text-2xl font-bold text-[#2C2C2C] mb-4" data-id="element-55">
        Terms of Service
      </h2>

      <section data-id="element-56">
        <h3 className="text-lg font-semibold text-[#2C2C2C] mb-2" data-id="element-57">
          Product Description
        </h3>
        <p className="text-[#4A4A4A]" data-id="element-58">
          The 7pm Menopause Sleep Reset is a digital PDF guide with accompanying
          tracker materials. Upon purchase, you will receive immediate access to
          download these materials.
        </p>
      </section>

      <section data-id="element-59">
        <h3 className="text-lg font-semibold text-[#2C2C2C] mb-2" data-id="element-60">
          Refund Policy
        </h3>
        <p className="text-[#4A4A4A]" data-id="element-61">
          Due to the digital nature of this product, all sales are final.
          However, if you experience technical issues accessing your purchase,
          please contact us and we'll resolve the issue promptly.
        </p>
      </section>

      <section data-id="element-62">
        <h3 className="text-lg font-semibold text-[#2C2C2C] mb-2" data-id="element-63">
          Medical Disclaimer
        </h3>
        <p className="text-[#4A4A4A]" data-id="element-64">
          This product is for educational and informational purposes only. It is
          not intended to diagnose, treat, cure, or prevent any disease or
          medical condition. Always consult with your healthcare provider before
          making changes to your health regimen, especially if you have existing
          medical conditions or are taking medications.
        </p>
      </section>

      <section data-id="element-65">
        <h3 className="text-lg font-semibold text-[#2C2C2C] mb-2" data-id="element-66">
          Intellectual Property
        </h3>
        <p className="text-[#4A4A4A]" data-id="element-67">
          All content in The 7pm Menopause Sleep Reset is protected by
          copyright. You may use the materials for your personal use only.
          Reproduction, distribution, or commercial use without written
          permission is prohibited.
        </p>
      </section>

      <section data-id="element-68">
        <h3 className="text-lg font-semibold text-[#2C2C2C] mb-2" data-id="element-69">
          No Guarantees
        </h3>
        <p className="text-[#4A4A4A]" data-id="element-70">
          While we've designed this system based on established sleep science
          principles, individual results may vary. We make no guarantees about
          specific outcomes, as sleep patterns are influenced by many individual
          factors.
        </p>
      </section>

      <section data-id="element-71">
        <h3 className="text-lg font-semibold text-[#2C2C2C] mb-2" data-id="element-72">
          Limitation of Liability
        </h3>
        <p className="text-[#4A4A4A]" data-id="element-73">
          We are not liable for any damages arising from the use or inability to
          use this product. Your use of the information is at your own risk.
        </p>
      </section>
    </div>;
  return <>
      <footer className="bg-[#2C2C2C] text-white/60 py-12" data-id="element-74">
        <div className="max-w-6xl mx-auto px-4 text-center" data-id="element-75">
          <p className="mb-4" data-id="element-76">
            &copy; {new Date().getFullYear()} The 7pm Menopause Sleep Reset. All
            rights reserved.
          </p>
          <div className="flex justify-center gap-6 text-sm" data-id="element-77">
            <button onClick={() => setActiveModal('privacy')} className="hover:text-white transition-colors underline" data-id="element-78">
              Privacy Policy
            </button>
            <button onClick={() => setActiveModal('terms')} className="hover:text-white transition-colors underline" data-id="element-79">
              Terms of Service
            </button>
          </div>
          <p className="mt-8 text-xs max-w-2xl mx-auto opacity-50" data-id="element-80">
            Disclaimer: This product is for educational purposes only and does
            not constitute medical advice. Always consult with your healthcare
            provider regarding medical conditions or changes to your health
            regimen.
          </p>
        </div>
      </footer>

      {/* Modal */}
      <AnimatePresence data-id="element-81">
        {activeModal && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4" onClick={() => setActiveModal(null)} data-id="element-82">
            <motion.div initial={{
          scale: 0.95,
          opacity: 0
        }} animate={{
          scale: 1,
          opacity: 1
        }} exit={{
          scale: 0.95,
          opacity: 0
        }} transition={{
          type: 'spring',
          duration: 0.3
        }} className="bg-white rounded-2xl max-w-2xl w-full max-h-[80vh] overflow-y-auto p-8 relative" onClick={e => e.stopPropagation()} data-id="element-83">
              <button onClick={() => setActiveModal(null)} className="absolute top-4 right-4 p-2 hover:bg-gray-100 rounded-full transition-colors" aria-label="Close modal" data-id="element-84">
                <X className="w-6 h-6 text-[#2C2C2C]" data-id="element-85" />
              </button>

              {activeModal === 'privacy' ? privacyContent : termsContent}

              <div className="mt-8 pt-6 border-t border-gray-200" data-id="element-86">
                <button onClick={() => setActiveModal(null)} className="w-full bg-[#FC8EAC] text-white py-3 px-6 rounded-md font-semibold hover:bg-[#E8739A] transition-colors" data-id="element-87">
                  Close
                </button>
              </div>
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </>;
}